export const maintenanceStartTime = new Date('2025-05-19T06:00:00');
export const maintenanceEndTime = new Date('2025-05-19T08:00:00');
export const displayStartTime = new Date('2025-05-12T12:00:00');
